import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ApiClientConfig} from '../api-client-config';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {
  Notification,
  NotificationCreateRequest,
  NotificationCreateResponse,
  NotificationPatchRequest,
  NotificationPatchResponse,
  PriorityPatchRequest
} from "@primatoo-ms-organization";
import {AgGridLangMap} from "@pt/pt-models";
import {TranslateService} from "@ngx-translate/core";
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';
import {ColumnType} from "it/primatoo/openapi/api/org/schemas/common/ColumnType";
import { ListNotificationResponse } from 'it/primatoo/openapi/api/org/schemas/notification/ListNotificationResponse';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService extends DataProtectionGovernanceService {
  private readonly endpoint: string;
  private readonly endpointV2: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    private translateService: TranslateService,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/notifications/';
    this.endpointV2 = this.config.endPoint + '/api/org/v2/notifications/';

  }

  public getNotifications(): Observable<ListNotificationResponse> {
    const url = this.endpointV2 + 'self/';
    return this.httpClient.get<ListNotificationResponse>(url);
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<void> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<void>(url, request);
  }

  /**
   * In Notification non è presente l'api
   */
  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const agGridLangMap = new AgGridLangMap(this.translateService.currentLang);

    return of([
      {
        type: ColumnType.NUMBER,
        column: 'id',
        label: agGridLangMap.getOf('id'),
        uiAvailable: true,
        uiUserShow: true,
        operations: []
      },
      {
        type: ColumnType.TEXT,
        column: 'entityType',
        label: agGridLangMap.getOf('entityType'),
        uiAvailable: true,
        uiUserShow: true,
        size: 200,
        operations: []
      },
      {
        type: ColumnType.DATE,
        column: 'date',
        label: agGridLangMap.getOf('date'),
        uiAvailable: true,
        uiUserShow: true,
        operations: []
      },
      {
        type: ColumnType.TEXT,
        column: 'userInfo',
        label: agGridLangMap.getOf('user'),
        uiAvailable: true,
        uiUserShow: true,
        size: 200,
        operations: []
      },
      {
        type: ColumnType.TEXT,
        column: 'note',
        label: agGridLangMap.getOf('note'),
        uiAvailable: true,
        uiUserShow: true,
        operations: []
      },

      {
        type: ColumnType.BOOLEAN,
        column: 'builtIn',
        label: agGridLangMap.getOf('builtIn'),
        uiAvailable: true,
        uiUserShow: true,
        operations: []
      },

      {
        type: ColumnType.NUMBER,
        column: 'entityId',
        label: agGridLangMap.getOf('entityId'),
        uiAvailable: true,
        uiUserShow: false,
        operations: []
      },

      {
        type: ColumnType.TEXT,
        column: 'userId',
        label: agGridLangMap.getOf('userId'),
        uiAvailable: true,
        uiUserShow: false,
        operations: []
      },

    ]);
  }

  public getNotificationById(id: number): Observable<Notification> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<Notification>(url);
  }

  public createNotification(requestBody: NotificationCreateRequest): Observable<NotificationCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<NotificationCreateResponse>(url, requestBody);
  }

  public updateNotification(id: number, requestBody: NotificationPatchRequest): Observable<NotificationPatchResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.patch<NotificationPatchResponse>(url, requestBody);
  }

  public deleteNotification(id: number): Observable<void> {
    const url = this.endpoint + 'self/' + id + '/';
    return this.httpClient.delete<void>(url);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
